import { Component, OnInit } from '@angular/core';
import { User_array, AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-terminate-user',
  templateUrl: './terminate-user.component.html',
  styleUrls: ['./terminate-user.component.scss']
})
export class TerminateUserComponent implements OnInit {
  user_arr: User_array = {
    user_name:'',
    password:''
  };
  user_response: any;
  user: string;
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  fname: string;
  lname: string;
  userEvaluator: boolean;
  constructor(private auth: AuthenticationService) { }

  ngOnInit(): void {
    this.getAccess();
  }
  // getAccess(){
  //   this.user = sessionStorage.getItem('user');
  //   if (this.user === '2') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '1') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = true;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '3') {
  //     this.userAdmin = false;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   }
  // }


  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }
  check_username(email){
    this.user_arr.user_name = email
    this.auth.check_user(this.user_arr).subscribe(
      (data) => {
       this.user_response=data.results
       if(data.code==500){
         Swal.fire({
         
          title: 'Alert',
        text: 'Invalid user',
        icon: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {

          }
        })
       }

      });
  }

  giveReaccess(){
    this.auth.giveReAccess(this.user_arr).subscribe(
      (data) => {
       this.user_response=data.results
       if(data.code==200){
         this.user_arr.user_name='';
         this.user_arr.password='';
       }

      });
  }
  terminate(){

    this.auth.terminateuser(this.user_arr).subscribe(
      (data) => {
       this.user_response=data.results
       if(data.code==200){
         this.user_arr.user_name='';
         this.user_arr.password='';
       }

      });
  }

}
